(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "reactDOM", "lodash"], factory);
	else if(typeof exports === 'object')
		exports["BookOnlineEditorMode"] = factory(require("react"), require("react-dom"), require("lodash"));
	else
		root["BookOnlineEditorMode"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7762__, __WEBPACK_EXTERNAL_MODULE__8677__, __WEBPACK_EXTERNAL_MODULE__7607__) {
return 